import { API } from "src/constants";

import { Http } from "../http";

import { ShopsResponse } from "./shops.types";

export const getShops = (): ShopsResponse => Http.get(`${API}/shops`);
